// extracted by mini-css-extract-plugin
export var settingsList = "_33-0";
export var settingsRow = "_33-1";
export var warningDot = "_33-2";